import React from "react";
import DetalleEquipoTorneo from "./DetalleEquipoTorneo.js";
import ListaPartidos from "./ListaPartidos.js";
import PosicionesTorneo from "./PosicionesTorneo.js";
import { Partidos as TipoLista } from "../../constantes/Filtros.js";
import styles from "./PrincipalTorneo.module.css";
import { NombreEquipoTorneo } from "../../funciones/FuncionesEquipo.js";

const PrincipalTorneo = (props) => {
  const datosElegidos = props.datosElegidos;

  //console.log("PrincipalTorneo datosElegidos", datosElegidos);

  let contenido = null;
  let titulo = "";
  if (datosElegidos.torneo) {
    titulo = datosElegidos.torneo.descripcion;
    if (datosElegidos.etapa) {
      if (datosElegidos.etapa.codigo === 0) {
        contenido = (
          <ListaPartidos
            tipoLista={TipoLista.FECHAS_ETAPA}
            datosElegidos={datosElegidos}
          />
        );
      } else {
        contenido = (
          <ListaPartidos
            tipoLista={TipoLista.ETAPA}
            datosElegidos={datosElegidos}
          />
        );
      }
    } else if (datosElegidos.equipo) {
      titulo += " - " + NombreEquipoTorneo(datosElegidos.equipo, datosElegidos.torneo);
      contenido = <DetalleEquipoTorneo datosElegidos={datosElegidos} />;
    } else {
      contenido = <PosicionesTorneo datosElegidos={datosElegidos} />;
    }
  }

  console.log("PrincipalTorneos", datosElegidos.torneo);

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.titulo}`}>{titulo}</div>
      {contenido}
    </div>
  );
};

export default PrincipalTorneo;